const GOOGLE_API_KEY="AIzaSyBl4elrWPXF8FkurjriGqAXh7oHQTG7PgQ"
export const YOUTUBE_VIDEOS_API=
"https://youtube.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails%2Cstatistics&chart=mostPopular&maxResults=100&regionCode=IN&key="+ 
GOOGLE_API_KEY;

export const GOOOGLE_SEARCH_KEY=
"http://suggestqueries.google.com/complete/search?client=firefox&ds=yt&q="